
import React, { useState } from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="header">
      
      <div className={`nav-links ${menuOpen ? "open" : ""}`}>
        <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>Home</Link>
        <Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>About</Link>
        <Link to="/projects" className="nav-link" onClick={() => setMenuOpen(false)}>Projects</Link>
        <Link to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>Contact</Link>
        <a href="https://drive.google.com/file/d/1HHaHXueuBOBcMU4tp2k8e9KQJM7G1QEn/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="nav-link" onClick={() => setMenuOpen(false)}>Resume</a>
      </div>

      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
         <FaBars />
      </div>
    </nav>
  );
};

export default Header;
